// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__14qpG","text":"SelectPayment_text__w6SBY","title":"SelectPayment_title__210VL","btn":"SelectPayment_btn__2QUju"};